/**
 * Weight bar — fills proportionally to current/max carry weight.
 * Overweight state renders in red (M3.3a C2).
 */

import styles from './inventory.module.css';

export interface WeightBarProps {
  current: number;
  max: number;
  /** Label prefix, e.g. "Carry" or "Container". */
  label?: string;
}

export function WeightBar({ current, max, label = 'Weight' }: WeightBarProps): JSX.Element {
  const ratio = max > 0 ? Math.min(current / max, 1) : 0;
  const overweight = current > max;
  const fillColor = overweight ? '#f87171' : ratio > 0.85 ? '#fbbf24' : '#4ade80';

  return (
    <div>
      <div className={styles.weightLabel}>
        <span>{label}</span>
        <span data-testid="weight-text">
          {current.toFixed(1)} / {max.toFixed(1)}
        </span>
      </div>
      <div className={styles.weightBarOuter} role="progressbar" aria-valuenow={current} aria-valuemin={0} aria-valuemax={max}>
        <div
          className={styles.weightBarFill}
          style={{
            width: `${(ratio * 100).toFixed(1)}%`,
            backgroundColor: fillColor,
          }}
        />
      </div>
    </div>
  );
}
